export default __webpack_public_path__ + "static/media/eye_crossed.48473640.svg";